import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_DASHBOARD_LAYOUT } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const dashboardLayout = {
  namespaced: true,
  state: buildInitialState({
    defaultDashboardLayout: [
      { 'x': 0, 'y': 0, 'w': 6, 'h': 18, 'i': 'headcount' },
      { 'x': 6, 'y': 0, 'w': 6, 'h': 18, 'i': 'nts' },
      { 'x': 0, 'y': 61, 'w': 12, 'h': 8, 'i': 'placement_goal' },
      { 'x': 6, 'y': 53, 'w': 6, 'h': 8, 'i': 'perm_placement_goal' },
      { 'x': 0, 'y': 34, 'w': 6, 'h': 19, 'i': 'ler' },
      { 'x': 0, 'y': 53, 'w': 6, 'h': 8, 'i': 'revenue' },
      { 'x': 0, 'y': 18, 'w': 12, 'h': 16, 'i': 'interviews' },
      { 'x': 6, 'y': 34, 'w': 6, 'h': 19, 'i': 'grossProfit' },
      { 'x': 0, 'y': 69, 'w': 12, 'h': 20, 'i': 'submissions' },
      { 'x': 0, 'y': 89, 'w': 6, 'h': 18, 'i': 'nts_by_employee' }
    ],
    defaultDashboardLayoutXS: [
      { 'x': 0, 'y': 0, 'w': 12, 'h': 18, 'i': 'headcount' },
      { 'x': 0, 'y': 18, 'w': 12, 'h': 18, 'i': 'nts' },
      { 'x': 0, 'y': 36, 'w': 12, 'h': 18, 'i': 'nts_by_employee' },
      { 'x': 0, 'y': 54, 'w': 12, 'h': 10, 'i': 'revenue' },
      { 'x': 0, 'y': 64, 'w': 12, 'h': 10, 'i': 'placement_goal' },
      { 'x': 0, 'y': 74, 'w': 12, 'h': 10, 'i': 'perm_placement_goal' },
      { 'x': 0, 'y': 84, 'w': 12, 'h': 18, 'i': 'ler' },
      { 'x': 0, 'y': 102, 'w': 12, 'h': 25, 'i': 'submissions' },
      { 'x': 0, 'y': 127, 'w': 12, 'h': 17, 'i': 'interviews' },
      { 'x': 0, 'y': 144, 'w': 12, 'h': 20, 'i': 'grossProfit' }
    ],
    currentDashboardLayout: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setDashboardLayoutItems: (state, dashboardLayoutItems) => {
      if (dashboardLayoutItems && dashboardLayoutItems.length > 0) {
        state.currentDashboardLayout = dashboardLayoutItems
      }
    },
    clearDashboardLayoutItems: (state) => {
      state.currentDashboardLayout = []
    }
  },
  actions: {
    getDashboardLayoutItems: ({ commit, dispatch }, userId) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting dashboard layout, please wait...' })

      return api.doGet({ path: PATH_DASHBOARD_LAYOUT, parameters: { userId: userId } })
        .then(json => json.data)
        .then(dashboardLayoutItems => {
          commit('updateStatus', { status: COMPLETE })
          commit('setDashboardLayoutItems', dashboardLayoutItems)
          hideProgressModal({ dispatch })
          return dashboardLayoutItems
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to get dashboard layout')
        })
    },
    saveDashboardLayout: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      return api.doPost({ path: PATH_DASHBOARD_LAYOUT, data: state.currentDashboardLayout })
        .then(response => {
          if (!response.data) {
            throw new Error('Unable to save dashboard layout.')
          }
          commit('setDashboardLayoutItems', response.data)
          commit('updateStatus', { status: COMPLETE })
          return response
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          hideProgressModal({ dispatch })
          notifyError(dispatch, 'Unable to save dashboard layout.')
          throw error
        })
    },
    clearDashboardLayoutItems ({ commit }) {
      commit('clearDashboardLayoutItems')
    }
  }
}

export default dashboardLayout
